import { render, staticRenderFns } from "./ContactoEjecutivo.vue?vue&type=template&id=355f79fa&scoped=true&"
import script from "./ContactoEjecutivo.vue?vue&type=script&lang=ts&"
export * from "./ContactoEjecutivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f79fa",
  null
  
)

export default component.exports